import { cn } from "@/lib/utils"
import { PersonPackageIcon } from "./person"

type PackageIconVariant = "green" | "blue" | "pink"
type PackageIconSize = "xs" | "sm" | "md" | "lg"

interface PackageIconProps {
  variant: PackageIconVariant
  size?: PackageIconSize
  className?: string
}

const bgByVariant: Record<PackageIconVariant, string> = {
  green: "bg-light-green-200",
  blue: "bg-light-blue-300",
  pink: "bg-aubergine-300",
}

const sizeConfig: Record<
  PackageIconSize,
  { container: string; icon: number; radius: string }
> = {
  // 16px circular — compact enough for dense layouts (e.g. comparison
  // grid headers) while matching the rounded-full treatment used by
  // the pricing cards' small-thumbnail variant.
  xs: { container: "w-4 h-4", icon: 12, radius: "rounded-full" },
  sm: { container: "w-9 h-9", icon: 24, radius: "rounded-[8px]" },
  md: { container: "w-[52px] h-[52px]", icon: 32, radius: "rounded-[10px]" },
  lg: { container: "w-16 h-16", icon: 48, radius: "rounded-[12px]" },
}

export function PackageIcon({
  variant,
  size = "sm",
  className,
}: PackageIconProps) {
  const { container, icon, radius } = sizeConfig[size]

  return (
    <div
      className={cn(
        container,
        radius,
        bgByVariant[variant],
        "flex flex-shrink-0 items-center justify-center",
        className
      )}
    >
      <PersonPackageIcon size={icon} className="text-black" />
    </div>
  )
}
